"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workspaceAdminApp = void 0;
exports.workspaceAdminApp = function (axios) {
    return {
        getWorkspaceAdminApps: function (request) {
            return axios.get('/apps', request);
        },
        getWorkspaceAdminAppsAppNo: function (request) {
            var appNo = request.pathParams.appNo;
            return axios.get("/apps/" + appNo);
        },
        getWorkspaceAdminAppsLatestReleased: function (request) {
            return axios.get('/apps/latest-released', request);
        },
        getWorkspaceAdminAppsPopular: function (request) {
            return axios.get('/apps/popular', request);
        }
    };
};
